module.exports = __webpack_public_path__ + "img/materialLogo.d2b1e190.png";